import { useEffect, useState } from "react";
import Header from "../Global/Header";
import Exam from "./Exam";
import { Loader } from "../Global/Loader";
import { base_url } from "../Api/Api";

const ExamList = () => {
  const [loading, setLoading] = useState(true);
  const [examList, setExamList] = useState([]);
  const [examCount, setExamCount] = useState(0);

  useEffect(() => {

    base_url
      .get(`exams`,)
      .then((res) => {
        setExamList(res.data.exams);
        setExamCount(res.data.active_exams_count);
      });
    setLoading(false);
  }, []);
  return (
    <>
      <Loader active={loading} />

      <div className={`${loading ? "" : "active"}  my-exams-list`}>
        <Header innerPage={true} title={"آزمون های من"} />
        {examList.length ? (
          <div className="exam-list">
            <div className="exam-count">
              <div className="count">
                <span>{examCount}</span>
                <span>ازمون فعال</span>
              </div>
            </div>
            <div className="exams">
              {examList.map((exam, i) => (
                <Exam key={i} exam={exam} />
              ))}
            </div>
          </div>
        ) : (
          <div className="empty-list">
            <i className="icon-exclamation" />
            <span>در حال حاضر آزمون فعالی وجود ندارد</span>
          </div>
        )}
      </div>
    </>
  );
};

export default ExamList;
